// utils/estadoMensaje.js
// Estado de un mensaje del chat de soporte, visto desde el DESTINATARIO:
//   pendiente = en cola (no estaba conectado / no abrió la conversación)
//   entregado = llegó, pero todavía no lo leyó
//   leido     = lo leyó
//
// Se centraliza acá porque el chat del usuario y el panel del admin tienen que
// mostrar la misma etiqueta y los mismos colores: antes "Entregado" usaba
// text-blue-100 sobre el fondo azul del mensaje y quedaba casi invisible.

export const normalizarEstado = (estado) => {
	if (estado === 'leido') return 'leido';
	if (estado === 'entregado') return 'entregado';
	return 'pendiente';
};

export const ETIQUETA_ESTADO = {
	pendiente: 'En cola',
	entregado: 'Entregado',
	leido: 'Leído',
};

// Colores de la leyenda. Pensados para leerse sobre el azul de los mensajes
// propios (bg-blue-500): por eso son tonos claros.
export const TEXTO_ESTADO = {
	pendiente: 'text-amber-200',
	entregado: 'text-sky-100',
	leido: 'text-green-200',
};

// Borde de los mensajes que el destinatario todavía no leyó:
//   en cola   -> punteado ámbar
//   entregado -> sólido celeste
//   leído     -> sin borde
export const claseBordeEstado = (estado) => {
	const normalizado = normalizarEstado(estado);
	if (normalizado === 'leido') return '';
	if (normalizado === 'pendiente') {
		return 'border-2 border-dashed border-amber-400 dark:border-amber-300';
	}
	return 'border-2 border-sky-400 dark:border-sky-300';
};
